module.exports = __webpack_public_path__ + "static/media/clutchLogin.a15d6db3.webp";